import React, { useEffect, useRef, useState } from 'react'
import Form from 'react-bootstrap/Form';
import { Col, Image, Row, Table } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form"
import { ErrorMessage } from '@hookform/error-message';
import './Home.css';
import { v4 as uuidV4 } from 'uuid';
import { companyUniqueId, TelInput, companyId, isCompanyActive, showSearchExistingConsentBtn, Navbar } from '../../components';
import { FormInputs, ICompany, ITenant } from '@models';
import CompanyService from '../../services/CompanyService';
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import { isLoading } from '../../components/Loader';
import OtpInput from 'react-otp-input';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import Pusher from 'pusher-js';

function Home() {
  const navigate = useNavigate();
  const tcpaRefId = useRef(null);
  const [token, setToken] = useState(uuidV4());
  const [hasLoadToken, setNewToken] = useState(true);
  const [companyInfo, setCompanyInfo] = useState<ICompany>();
  const [tenantInfo, setTenantInfo] = useState<ITenant>();
  const { uniqueId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const [compUniqueId, setCompUniqueId] = useRecoilState(companyUniqueId);
  const [showSearchBar, setShowSearchBar] = useRecoilState(showSearchExistingConsentBtn);
  const [compId, setCompId] = useRecoilState(companyId);
  const [companyActive, setCompanyActive] = useRecoilState(isCompanyActive);
  const [showMessage, setShowMsg] = useState(false);

  const setIsLoading = useSetRecoilState(isLoading);
  const showLoading = useRecoilValue(isLoading);
  const [otp, setOtp] = useState('');
  const [tcpaRefNo, setTCPARefNo] = useState('');
  const [showOTPVerification, setShowOTPVerification] = useState(false);
  const [showConsentMessage, setShowConsentMessage] = useState(false);
  const [showConsentFormLinkSent, setShowConsentFormLinkSent] = useState(false);
  const [showConsentStatus, setShowConsentStatus] = useState(false);
  const [clidPresent, setCLIDPresent] = useState(false);

  const [consentStatus, setConsentStatus] = useState('timeout');

  const [serverCallInprogress, setServerCallInprogress] = useState(false);
  const [selectedConsentLanguage, setSelectedConsentLanguage] = useState(null);

  const [showOTPError, setShowOTPError] = useState(false);
  const [startInterval, setStartInterval] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [otpErrorMessage, setOTPErrorMessage] = useState("");
  const [tcpaMsgSentNumber, setTcpaMsgSentNumber] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showDynamicField, setShowDynamicField] = useState(false);
  const [showConsentFormLinkReview, setShowConsentFormLinkReview] = useState(false);
  const [showConsentFormLinkResult, setShowConsentFormLinkResult] = useState(false);
  const [consentRequestResult, setConsentRequestResult] = useState<any>(null);
  // const [isCompanyActive, setCompanyActive] = useState(false);

  const handleCloseConsentFormReview = () => {
    setShowConsentFormLinkReview(false);
  }

  const handleCloseConsentFormRequest = () => {
    setShowConsentFormLinkSent(false);
  };

  const handleClearQueryString = () => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const params = new URLSearchParams(url.search);

    // Iterate through each key and delete it
    for (const key of Array.from(params.keys())) {
      params.delete(key);
    }

    setValue("firstName", "");
    setValue("lastName", "");
    setValue("mobileNumber", "");
    setValue("clid", "");
    setValue("brand", "");
    setValue("beneficiary", "");

    // Update the URL with the modified query string
    navigate(url.pathname + '?' + params.toString());
  };
  const [requestFormBody, setRequestFormBody] = useState<any>(null);
  var interval: any | undefined;
  const {
    register,
    control, trigger, reset,
    setError,
    setFocus,
    clearErrors,
    setValue, getValues,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInputs>()

  const onSubmit = async (formData: FormInputs) => {
    if (serverCallInprogress) {
      return false;
    }

    let data = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      mobile_number: formData.mobileNumber,
      consent_lang_id: formData.consentLanguage,
      contactid: searchParams.get('contactid'),
      brand: formData.brand,
      bene: formData.beneficiary,
      token: token
    }

    setServerCallInprogress(true);
    setErrorMessage("");
    setTcpaMsgSentNumber("");
    CompanyService.submitForm(compUniqueId, data)
      .then((response: any) => {
        reset();
        setNewToken(!hasLoadToken);
        data.token = token;
        setRequestFormBody(data);
        console.log(response.data);
        tcpaRefId.current = response.data.ref_no;
        if (response.data.is_form) {
          setShowConsentFormLinkSent(true);
          handleInterval();
        } else {
          setShowOTPVerification(true);
          setShowDynamicField(false);
          setCLIDPresent(false);
        }
        console.log("consentLanguage", companyInfo?.consent_languages[0].uuid);
        setValue("consentLanguage", companyInfo?.consent_languages[0].uuid ?? "");
        setTCPARefNo(response.data.ref_no);
        setTcpaMsgSentNumber(response.data.sent_mobile_number);
        setServerCallInprogress(false);
      })
      .catch((e: any) => {
        if (e.response) {
          console.log(e.response); // => the response payload 
          setErrorMessage(e.response.data.message);
          setShowErrorModal(true);
          if (e.response.status === 401) {
            setCompanyActive(false);
          }
        }
        setNewToken(!hasLoadToken);
        setServerCallInprogress(false);
      });
  }

  const reSubmitForm = () => {
    if (serverCallInprogress) {
      return false;
    }

    setNewToken(!hasLoadToken);
    let data = requestFormBody;
    data.token = token;
    console.log("reSubmitForm data:", data);
    setServerCallInprogress(true);
    setErrorMessage("");
    setTcpaMsgSentNumber("");
    CompanyService.submitForm(compUniqueId, data)
      .then((response: any) => {
        reset();
        console.log(response.data);
        tcpaRefId.current = response.data.ref_no;
        setShowConsentFormLinkResult(false);
        setShowConsentFormLinkSent(true);
        handleInterval();
        console.log("consentLanguage", companyInfo?.consent_languages[0].uuid);
        setValue("consentLanguage", companyInfo?.consent_languages[0].uuid ?? "");
        setTCPARefNo(response.data.ref_no);
        setTcpaMsgSentNumber(response.data.sent_mobile_number);
        setServerCallInprogress(false);
      })
      .catch((e: any) => {
        if (e.response) {
          console.log(e.response); // => the response payload 
          setErrorMessage(e.response.data.message);
          setShowErrorModal(true);
          if (e.response.status === 401) {
            setCompanyActive(false);
          }
        }
        setNewToken(!hasLoadToken);
        setServerCallInprogress(false);
      });
  }
  const getCompany = () => {
    console.log("Company Unique ID : ", uniqueId);
    setIsLoading(true);
    CompanyService.getInfo(uniqueId?.toString() ?? "")
      .then((response: any) => {
        console.log("Company DAta", response.data)
        if (response.data.info.status === "INACTIVE" || response.data.info.paused_status === "PAUSED") {
          setCompanyActive(false);
        } else if (response.data.info.status === "CANCELED") {
          window.location.href = "https://callerconsent.com/";
        } else {
          setCompanyActive(true);
        }

        console.log("Clid : " + searchParams.get("clid"));
        if (response.data.info.consent_languages.length > 0) {
          if (searchParams.has("clid") && searchParams.get("clid")?.trim() !== "") {
            let selectedItem = response.data.info.consent_languages.filter((item: any) => {
              if (item.uuid === searchParams.get("clid")) {
                return item;
              }
            });
            response.data.info.consent_languages = selectedItem;
            setCLIDPresent(true);
          } else {
            setCLIDPresent(false);
            setShowDynamicField(false);
          }

          if (response.data.info.consent_languages[0].type === "DYNAMIC") {
            setShowDynamicField(true);
          }

          setValue("consentLanguage", response.data.info.consent_languages[0].uuid);
          setSelectedConsentLanguage(response.data.info.consent_languages[0].uuid);
        }

        setCompanyInfo(response.data.info);
        setTenantInfo(response.data.tenant);

        setCompId(response.data.info.id);
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      })
      .catch((e: Error) => {
        console.log(e);
        setIsLoading(false);
        setShowErrorModal(true);
        setErrorMessage(e.message);
        navigate('/page/not-found');
      });
  };

  useEffect(() => {
    const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY ?? "", {
      cluster: process.env.REACT_APP_PUSHER_CLUSTER ?? ""
    })

    console.log(pusher, "pusher")
    const channel1 = pusher.subscribe('tcpa-channel');

    channel1.bind('consent-language-update', function (data: any) {
      console.log("pusher data received", data)
      consentLangUpdate(data);
    })
    channel1.bind('company-status-change', function (data: any) {
      console.log("pusher data received", data)
      checkCompanyStatus(data);
    })

    channel1.bind('web-status-update', function (data: any) {
      console.log("web consent status data received", data)
      if (data.message.ref_id === tcpaRefId.current) {
        if (interval) {
          clearInterval(interval);
        }
        setServerCallInprogress(false);
        setConsentStatus(data.message.status);
        setShowConsentMessage(false);
        setTimeout(() => {
          setShowConsentStatus(true);
        }, 300);
      }
    })

    setValue("firstName", searchParams.get("fname") ?? "");
    setValue("lastName", searchParams.get("lname") ?? "");
    setValue("mobileNumber", searchParams.get("mobile") ?? "");
    setValue("brand", searchParams.get("brand") ?? "");
    setValue("beneficiary", searchParams.get("bene") ?? "");
    setValue("clid", searchParams.get("clid") ?? "");
    setValue("consentLanguage", searchParams.get("clid") ?? "");
    if (searchParams.has("clid") && searchParams.get("clid")?.trim() !== "") {
      setCLIDPresent(true);
    } else {
      setCLIDPresent(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const consentLangUpdate = (data: any) => {
    console.log("pusher data consentLangUpdate", data)
    console.log("pusher company id : " + uniqueId, data.message.company_id)
    if (uniqueId === data.message.company_id) {
      getCompany();
    }
  }
  const checkCompanyStatus = (data: any) => {
    console.log("pusher data checkCompanyStatus", data)
    console.log("pusher company id : " + uniqueId, data.data.company_id)
    if (uniqueId === data.data.company_id) {
      if (data.data.status === "INACTIVE") {
        setCompanyActive(false);
      } else {
        setCompanyActive(true);
      }
    }
  }
  useEffect(() => {
    console.log("unique id : " + uniqueId);
    if (uniqueId && uniqueId !== "") {
      let newUniqueId = uniqueId;
      setCompUniqueId(newUniqueId);
      setShowSearchBar(true);
    }
  }, [uniqueId]);

  useEffect(() => {
    if (compUniqueId && compUniqueId !== "") {
      getCompany();
    }
  }, [compUniqueId])
  const handleCopyToClipboard = (text: string) => {
    window.navigator.clipboard.writeText(text);
    setShowMsg(true);
    setTimeout(() => {
      setShowMsg(false);
    }, 3000);
  };
  const checkConsentResult = () => {
    if (serverCallInprogress) {
      return false;
    }
    setServerCallInprogress(true);
    CompanyService.checkConsentResponse(compUniqueId, tcpaRefId.current ?? "")
      .then((response: any) => {
        if (response.data.result !== "pending") {
          if (interval) {
            clearInterval(interval);
          }
          setServerCallInprogress(false);
          if (response.data.result === "reviewed") {
            setShowConsentFormLinkReview(true);
            setShowConsentFormLinkSent(false);
            handleInterval();
          } else if (response.data.result === "opt-in-submitted") {
            setConsentRequestResult(response.data);
            setShowConsentFormLinkReview(false);
            setShowConsentFormLinkResult(true);
          } else {
            setConsentStatus(response.data.result);
            setShowConsentMessage(false);
            setTimeout(() => {
              setShowConsentStatus(true);
            }, 300);
          }
        }
      })
      .catch((e: Error) => {
        console.log(e); setServerCallInprogress(false);
      });
  }

  useEffect(() => {
    // Generate a unique token on component mount
    setToken(uuidV4());
  }, [hasLoadToken]);

  const handleCloseOTPVerification = () => setShowOTPVerification(false);
  const handleCloseErrorModal = () => {
    setShowErrorModal(false);
    handleClearQueryString();
  }

  const handleCloseConsentMessage = () => setShowConsentMessage(false);

  const handleCloseConsentStatus = () => {
    console.log("handleCloseConsentStatus called");
    setTCPARefNo('');
    setShowConsentStatus(false);
    setShowConsentFormLinkResult(false);
    setShowConsentFormLinkReview(false);
    setShowConsentFormLinkSent(false);
    handleClearQueryString();
  };

  const handleCloseConsentFormLinkResult = () => {
    setShowConsentFormLinkResult(false);
    handleClearQueryString();
  }

  const handleOTPVerification = () => {
    if (otp === '') {
      setOTPErrorMessage("Please enter OTP.");
      return false;
    }
    if (serverCallInprogress) {
      return false;
    }
    setServerCallInprogress(true);
    setOTPErrorMessage("");
    setTcpaMsgSentNumber("");
    CompanyService.verifyOTP(compUniqueId, tcpaRefId.current ?? "", { otp: otp })
      .then((response: any) => {
        setOtp('');
        setShowOTPVerification(false);
        setServerCallInprogress(false);
        setTimeout(() => {
          setShowConsentMessage(true);
          handleInterval();
        }, 300);
      })
      .catch((e: any) => {
        console.log(e);
        if (e.response.data) {
          setOTPErrorMessage(e.response.data.message);
        }
        setServerCallInprogress(false);
      });
  }

  const handleInterval = () => {
    interval = setInterval(() => {
      checkConsentResult();
    }, 5000);
  }

  const timerProps = {
    isPlaying: true,
    size: 120,
    strokeWidth: 6
  };
  const minuteSeconds = 120;
  const getTimeSeconds = (time: number) => (minuteSeconds - time) | 0;

  const renderTime = (dimension: string, time: number) => {
    return (
      <div className="time-wrapper text-center">
        <div className="time text-danger">{time}</div>
        <div>{dimension}</div>
      </div>
    );
  };

  const handleTimerComplete = () => {

    setShowConsentMessage(false);
    setShowConsentStatus(true);
  }
  const handleError = (e: any) => {
    console.log("handleError:", e);
  }

  const handleConsentLanguageSelect = (obj: any) => {
    console.log("handleConsentLanguageSelect:", obj);
    // if (obj.uuid === selectedConsentLanguage) {
    //   setSelectedConsentLanguage(null);
    //   setValue("consentLanguage", "");
    // } else {
    setValue("consentLanguage", obj.uuid);
    setSelectedConsentLanguage(obj.uuid);


    if (obj.type === "DYNAMIC") {
      setShowDynamicField(true);
    } else {
      setValue("beneficiary", "");
      setValue("brand", "");

      setShowDynamicField(false);
      clearErrors("beneficiary");
      clearErrors("brand");
    }
    clearErrors("consentLanguage");
    // }

  }
  return (
    !showLoading ?
      <>
        <Navbar tenantInfo={tenantInfo} />
        <div className='container'>
          <div className='container mt-4'>
            {
              !companyActive ? <div className="alert alert-danger" role="alert" >
                This account is currently inactive. Please reactivate or contact <a href="mailto:info@tcpatech.com">info@tcpatech.com</a>.</div>
                : null
            }

            <form onSubmit={handleSubmit(onSubmit, handleError)}>
              <div className='mainbg p-4'>
                <div className='row'>
                  <div className='col-lg-6 '>
                    <Image
                      src={companyInfo?.logo}
                      height={50}
                      style={{ height: "50px !important;" }}
                      alt="logo"
                    />
                  </div>
                  <div className='col-lg-6 mb-4'>
                    {/* <div className='text-danger attention'>
                      <h4>ATTENTION!</h4>
                      <p>Please inform your caller that the text will come from; 855-598-9889<br />
                        Your caller will have 2 minutes to complete the Opt-In.
                      </p>
                    </div> */}
                  </div>
                  <div className='col-lg-4 mb-3 mt-4'>
                    <Form.Label htmlFor="txtFirstName" className='mb-1'>Caller First Name *</Form.Label>
                    <Form.Control
                      type="text"
                      id="txtFirstName"
                      placeholder='Enter First Name'
                      autoComplete="off"
                      {...register("firstName", { required: "Please enter first name." })}
                    />
                    <ErrorMessage name="firstName" errors={errors} render={({ message }) => <p className="error-message">{message}</p>} />
                  </div>
                  <div className='col-lg-4 mb-3 mt-4'>
                    <Form.Label htmlFor="txtLastName" className='mb-1'>Caller Last Name *</Form.Label>
                    <Form.Control
                      type="text"
                      aria-describedby="passwordHelpBlock"
                      placeholder='Enter Last Name'
                      autoComplete="off"
                      {...register("lastName", { required: "Please enter last name." })}
                    />
                    <ErrorMessage name="lastName" errors={errors} render={({ message }) => <p className="error-message">{message}</p>} />

                  </div>
                  <div className='col-lg-4 mb-3 mt-4'>
                    <Form.Label htmlFor="txtMobileNumber" className='mb-1'>Caller Mobile Phone *</Form.Label>
                    <div>
                      <TelInput useFormMethods={
                        {
                          register,
                          control,
                          trigger
                        }
                      } name="mobileNumber" required={true} schema={{
                        errorMessage: {
                          required: "Please enter phone number",
                          // validate: 'Please enter a valid phone number.'
                        }
                      }} ></TelInput>
                    </div>
                    <ErrorMessage name="mobileNumber" errors={errors} render={({ message }) => <p className="error-message">{message}</p>} />
                  </div>

                  <div className='col-lg-12 mb-3'>
                    <Form.Label htmlFor="ddConsentLanguage" className='mb-1'>Select the Company to Request Consent For *</Form.Label>
                    {/* <Form.Select
                      disabled={clidPresent}
                      {...register("consentLanguage", { required: "Please select consent language." })}
                      aria-label="Default select example">
                      {companyInfo?.consent_languages !== undefined && companyInfo?.consent_languages.length > 0 ?
                        companyInfo?.consent_languages.map((item: any, index: number) => {
                          return (
                            <option key={item.uuid} value={item.uuid}>{item.title}</option>
                          )
                        }) : <option value="">Select Language</option>
                      }
                    </Form.Select> */}

                    <div className="text-center pty">
                      <Row className="row-cols-6 row-cols-lg-6 g-lg-6 g-6"

                        {...register("consentLanguage", { required: "Please select consent language." })}>
                        {companyInfo?.consent_languages !== undefined && companyInfo?.consent_languages.length > 0 ? companyInfo?.consent_languages?.map((option: any, ind: any) => {
                          return (
                            <Col className='mt-2' lg={2} md={3} xl={2} xxl={2} xs={6} sm={6}>
                              <span
                                onClick={() => {
                                  handleConsentLanguageSelect(option);
                                }}
                              >
                                <div
                                  id={option.uuid}
                                  className="card-box cursor-pointer"
                                  style={{
                                    border: "",
                                    position: "relative",
                                    cursor: clidPresent ? "not-allowed" : "pointer"
                                  }}
                                >
                                  <img
                                    src={option.icon}
                                    alt=""
                                    className="img-fluid cursor-pointer"
                                  />
                                  {option.uuid === selectedConsentLanguage && (
                                    <div
                                      style={{
                                        color: '#004aad',
                                        position: "absolute",
                                        top: "-21px",
                                        right: "4px",
                                        zIndex: 1,
                                      }}
                                    >
                                      <img src="/img/checkmark.png" alt="Selected" width={18} height={18} />
                                    </div>
                                  )}
                                </div>
                                <div style={{
                                  fontFamily: '"Inter", sans-serif',
                                  fontWeight: 700,
                                  fontSize: '14px',
                                  lineHeight: '15px',
                                  marginTop: '4px'
                                }}>{option.title}</div>
                              </span>
                            </Col>
                          );
                        }) : <div>
                          <Form.Label style={{
                            fontFamily: '"Inter", sans-serif',
                            fontWeight: 700,
                            marginTop: '4px',
                            color: 'red'
                          }}>No Consent Found</Form.Label>
                        </div>}
                      </Row>
                    </div>

                    <ErrorMessage name="consentLanguage" errors={errors} render={({ message }) => <p className="error-message">{message}</p>}
                    />
                  </div>



                  {showDynamicField ?
                    <>

                      <div className='col-lg-4 mb-3'>
                        <Form.Label htmlFor="txtBrand" className='mb-1'>Brand to Display *</Form.Label>
                        <Form.Control
                          type="text"
                          id="txtBrand"
                          placeholder='Enter Brand'
                          autoComplete="off"
                          {...register("brand", { required: "Please enter brand." })}
                        />
                        <ErrorMessage name="brand" errors={errors} render={({ message }) => <p className="error-message">{message}</p>} />
                      </div>
                      <div className='col-lg-4 mb-3' >
                        <Form.Label htmlFor="txtBene" className='mb-1'>Beneficiary - Who is the Consent For? *</Form.Label>
                        <Form.Control
                          type="text"
                          id="txtBene"
                          placeholder='Enter Beneficiary '
                          autoComplete="off"
                          {...register("beneficiary", { required: "Please enter beneficiary." })}
                        />
                        <ErrorMessage name="beneficiary" errors={errors} render={({ message }) => <p className="error-message">{message}</p>} />
                      </div>
                    </> : null}

                  <div className='col-lg-12'>
                    <label className="containercheck">As the Agent, I confirm that I have obtained verbal consent to send a one-time text message to the person and number provided above for the purposes of gaining his or her express written consent
                      <input type="checkbox" {...register("acceptTermsAndCondition", { required: "You must accept terms and conditions" })} ></input>
                      <span className="checkmark"></span>
                    </label>
                    <ErrorMessage name="acceptTermsAndCondition" errors={errors} render={({ message }) => <p className="error-message">{message}</p>} />
                  </div>
                  <div className='col-lg-6 mt-3'>
                    <button type="submit" disabled={!companyActive} className='mainbutton btn px-4' >Send Opt-In Request</button>
                  </div>
                  <div style={{ flexDirection: 'column' }} className='label containercheck col-lg-6  txt-right  my-auto'>
                    {/* <span className='inter'>All messages will be sent from {companyInfo?.formatted_telnyx_tollfree_number}</span><br/> */}
                    <span className='mt-1 inter'>For help or support, please email <a href="mailto:info@tcpatech.com">info@tcpatech.com</a>.</span>
                  </div>
                </div>
              </div>
            </form>
            {/* <Image
              src="/img/instantconnenct.png"
              width={120}
              height={50}
              alt="logo"
              className="img-fluid mt-3"
            /> */}

          </div>
        </div>

        {/* Verification OTP Modal */}
        <Modal backdrop="static"
          keyboard={false} onHide={handleCloseOTPVerification} show={showOTPVerification} >
          <Modal.Header closeButton>
            <Modal.Title> <h5>Two-Factor Authentication</h5></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='col-lg-12'>

              <div className='col-lg-12 mb-3'>
                <h6 className='text-center'>Please enter the 4 digit verification<br />
                  Code sent to the Caller</h6>
                <div className="d-flex justify-content-center col-6 mx-auto">
                  <div>
                    <OtpInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={4}
                      shouldAutoFocus={true}
                      renderSeparator={<span>&nbsp;&nbsp;</span>}
                      inputStyle="form-control w-100"
                      inputType="tel"
                      renderInput={(props) => <input  {...props} />}
                    />
                  </div>
                </div>
                {otpErrorMessage !== "" ? <div className="d-flex col-6 mx-auto">
                  <div className="error-message">{otpErrorMessage}</div></div> : null}
                <center className='mt-3'>

                  <button className='mainbutton btn px-4 mb-2' type='button' onClick={handleOTPVerification}>Submit</button><br /><br />
                  <div>Message was sent from {tcpaMsgSentNumber}</div>
                  TCPATech Reference Code : {tcpaRefId.current}</center>
              </div>
            </div>
          </Modal.Body>

        </Modal>

        {/* Consent Message Sent */}
        <Modal backdrop="static"
          keyboard={false} onHide={handleCloseConsentMessage} show={showConsentMessage} >
          <Modal.Header >
            <Modal.Title> <h5>Authentication Passed</h5></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='col-lg-12'>
              <div className='col-lg-12 mb-3'>
                <h3 className='text-center'>Consent language has been sent.<br />
                  Waiting for Caller response.</h3><br />
                <h5 className='text-center'>
                  Please instruct Caller to review the consent and reply "Yes" to Opt-In.
                </h5><br />
                <div className="d-flex justify-content-center col-6 mx-auto">
                  <CountdownCircleTimer
                    {...timerProps}
                    colors="#dc3545"
                    duration={minuteSeconds}
                    onComplete={handleTimerComplete} >
                    {({ elapsedTime, color }) => (
                      <span>
                        {renderTime("seconds", getTimeSeconds(elapsedTime))}
                      </span>
                    )}
                  </CountdownCircleTimer>
                </div>
                <center className='mt-3'>
                  <br />
                  TCPATech Reference Code : {tcpaRefId.current}</center>
              </div>
            </div>
          </Modal.Body>

        </Modal>

        {/* Consent Link Sent */}
        <Modal backdrop="static"
          keyboard={false} onHide={handleCloseConsentFormRequest} show={showConsentFormLinkSent} >
          <Modal.Header >
            <Modal.Title> <h5>Link Sent- Consent Form Request</h5></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='col-lg-12'>
              <div className='col-lg-12 mb-3'>
                <h5 className='text-center'>
                  Please instruct caller to complete the form and click the "I Agree" button.
                </h5><br />

                <center className='mt-3'>
                  <div>Message was sent from {tcpaMsgSentNumber}</div>
                  <br />
                  TCPATech Reference Code : {tcpaRefId.current}

                </center>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Consent Link Sent */}
        <Modal backdrop="static"
          keyboard={false} onHide={handleCloseConsentFormReview} show={showConsentFormLinkReview} >
          <Modal.Header >
            <Modal.Title> <h5>Link Clicked- Caller Reviewing</h5></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='col-lg-12'>
              <div className='col-lg-12 mb-3'>
                <h5 className='text-center'>
                  Please instruct caller to complete the form and click the "I Agree" button.
                </h5><br />
                <div className="d-flex justify-content-center col-6 mx-auto">
                  <CountdownCircleTimer
                    {...timerProps}
                    colors="#dc3545"
                    duration={minuteSeconds}
                    onComplete={handleTimerComplete} >
                    {({ elapsedTime, color }) => (
                      <span>
                        {renderTime("seconds", getTimeSeconds(elapsedTime))}
                      </span>
                    )}
                  </CountdownCircleTimer>
                </div>
                <center className='mt-3'>
                  <br />
                  TCPATech Reference Code : {tcpaRefId.current}</center>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Consent Link Result */}
        <Modal backdrop="static"
          keyboard={false} onHide={handleCloseConsentFormLinkResult} show={showConsentFormLinkResult} >
          <Modal.Header closeButton>
            <Modal.Title> <h5>Consent Status</h5></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='col-lg-12'>
              <div className='col-lg-12 mb-3'>
                <h4 className='text-center text-success'>OPT-IN CONFIRMED</h4>
                {!consentRequestResult?.matched &&
                  <div className="justify-content-center mt-3 mb-3 mx-auto" >
                    <p className='text-center text-danger'><h5>Alert- Data Provided Does Not Match</h5></p>
                    <p className='text-center text-danger'>It is important that this information is accurate. Please review with the caller and submit another request if needed.</p>
                  </div>
                }
                <div className="d-flex justify-content-center col-12 mx-auto">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col">Requested</th>
                        <th scope="col">Provided</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">First Name</th>
                        <td>{consentRequestResult?.requested?.first_name}</td>
                        <td className={consentRequestResult?.f_matched ? "" : "fw-bold text-danger"}>{consentRequestResult?.user?.first_name}</td>
                      </tr>
                      <tr>
                        <th scope="row">Last Name</th>
                        <td>{consentRequestResult?.requested?.last_name}</td>
                        <td className={consentRequestResult?.l_matched ? "" : "fw-bold text-danger"}>{consentRequestResult?.user?.last_name}</td>
                      </tr>
                      <tr>
                        <th scope="row">Phone Number</th>
                        <td>{consentRequestResult?.requested?.mobile_number}</td>
                        <td className={consentRequestResult?.m_matched ? "" : "fw-bold text-danger"}>{consentRequestResult?.user?.mobile_number}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <center className='mt-3'>
                  {!consentRequestResult?.matched && <div>
                    <button className='mainbutton btn px-4 mb-2' type='button' onClick={() => reSubmitForm()} >Submit Another Request</button>
                  </div>}
                  <br />
                  TCPATech Reference Code : {tcpaRefId.current}<br />
                  <button onClick={() =>
                    handleCopyToClipboard(
                      consentRequestResult?.user?.trusted_form_url
                    )
                  } type='button' className='btn btn-sm btn-outline-primary mt-1'>
                    Copy TrustedForm CertURL
                  </button>
                  {showMessage && (
                    <div style={{ fontSize: "12px", color: "#004aad" }}>
                      Copied to clipboard!
                    </div>
                  )}
                </center>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className='mainbutton btn px-4 mb-2' type='button' onClick={handleCloseConsentFormLinkResult}>Close</button>
          </Modal.Footer>
        </Modal>

        {/* Consent Message Status Modal */}
        <Modal backdrop="static"
          keyboard={false} onHide={handleCloseConsentStatus} show={showConsentStatus} >
          <Modal.Header closeButton>
            <Modal.Title> <h5>Consent Status</h5></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='col-lg-12'>
              <div className='col-lg-12 mb-3'>
                {consentStatus === 'reviewed' ?
                  <>
                    <h4 className='text-center text-success'>Link Clicked- Caller Reviewing</h4>
                    <div className="d-flex mt-3 justify-content-center  mx-auto">
                      <p><h5>The Caller has reviewing consent form.</h5></p>
                    </div></>
                  : null}

                {consentStatus === 'opt-in' ?
                  <>
                    <h4 className='text-center text-success'>OPT-IN CONFIRMED</h4>
                    <div className="d-flex mt-3 justify-content-center  mx-auto">
                      <p><h5>The Caller has provided consent.</h5></p>
                    </div></>
                  : null}

                {consentStatus === 'opt-out' ? <>
                  <h4 className='text-center text-danger'>OPT-IN DECLINED</h4>
                  <div className="d-flex mt-3 justify-content-center  mx-auto">
                    <p><h5>The Caller has declined consent.</h5></p>
                  </div>
                </>
                  : null}
                {consentStatus === 'consent-denied' ? <>
                  <h4 className='text-center text-danger'>CONSENT DENIED</h4>
                  <div className="d-flex mt-3 justify-content-center  mx-auto">
                    <p><h5>The Caller has denied consent.</h5></p>
                  </div>
                </>
                  : null}
                {consentStatus === 'timeout' ?
                  <>
                    <h4 className='text-center' style={{ color: "#adb2b6" }}>OPT-IN TIMED OUT</h4>
                    <div className="d-flex mt-3 justify-content-center  mx-auto">
                      <p><h5>The request for Consent has timed out.</h5></p>
                    </div>
                  </>
                  : null}

                <div className="d-flex mt-3 justify-content-center  mx-auto">
                  <h6>You may close this window and proceed with the call.</h6>
                </div>
              </div>

              <center className='mt-3'>
                <button className='mainbutton btn px-4 mb-2' type='button' onClick={handleCloseConsentStatus}>Close</button><br /><br />
                TCPATech Reference Code : {tcpaRefId.current}
              </center>
            </div>
          </Modal.Body>

        </Modal>

        {/* Error Modal */}
        <Modal backdrop="static"
          keyboard={false} onHide={handleCloseErrorModal} show={showErrorModal} >
          <Modal.Header closeButton>
            <Modal.Title> <h5>Alert</h5></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='col-lg-12'>
              <h5>{errorMessage}</h5>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className='mainbutton btn px-4 mb-2' type='button' onClick={handleCloseErrorModal}>Close</button>
          </Modal.Footer>
        </Modal>

      </>
      : null
  )
}

export default Home
